import axios from "axios";

const GetOutstandingToolsDetails = async () => {
  return Promise.resolve({ data: { StatusCode: 200, ResultSet: [] } });
};

export default {
  GetOutstandingToolsDetails
};